// slide overlay div to top SCROLL UP
$(".submenu-points__menu").click(function() {
  $('html,body').animate({
    scrollTop: $(".home-section__overlay").offset().top + 770
  }, 'slow');
});

$(".submenu-points__latest").click(function() {
  $('.layout-wrapper').load('page.html');
  $('html,body').animate({
    scrollTop: $(".home-section__main").offset()
  }, 'slow');
});



// WEBPACK FOOTER //
// ./assets/js/features/events.js